<template>
    <div class="card-box-small border-radius-8 text-center text-sm-left p-4 dashboard-box">
        <h4 class="font-poppins font-weight-light color-blue" v-if="title">{{ title }}</h4>
        <h1 class="main-content font-poppins font-weight-light text-fire-orange w-100 my-3" v-if="mainContent">
            {{ mainContent }}
        </h1>
        <p class="color-dark-blue mb-0" v-if="extraInfo">
            {{ extraInfo }}
        </p>
        <slot/>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: null
        },
        mainContent: {
            type: [String, Number],
            default: null
        },
        extraInfo: {
            type: String,
            default: null
        }
    }
}
</script>
